module.exports = __webpack_public_path__ + "img/外部链接.40e94237.png";